export const initState = {
  isLoading: false,
  companyData: [],
};

export default {
  ...initState,
};
